'use strict';

/**
 * ImageGallery
 *
 * @author Matthias Giger <matthias.giger@namics.com>
 */
T.Module.ImageGallery = T.createModule({

	_selectors: {
		image: '[data-js-o-image-gallery__image]',
		imageMfp: '[data-js-o-image-gallery__mfp]',
		button: '[data-js-o-image-gallery__button]',
		imageImg: '[data-js-a-image__img]',
		wideImage: '[data-js-half]',
		galleryLeftArrow: '.mfp-arrow-left',
		galleryRightArrow: '.mfp-arrow-right'
	},

	_stateClasses: {
		objectfitPolyfill: 'state-objectfit-polyfill'
	},

	start: function start(resolve) {
		this.$ctx = $(this._ctx);

		this.$images = this.$ctx.find(this._selectors.image);
		this.$button = this.$ctx.find(this._selectors.button);

		this.$button.click(this.$onButtonClick.bind(this));

		this._events.on('t.sync', this.sync.bind(this));
		$(document).on('lazybeforeunveil', this.onBeforeUnveilImage.bind(this));

		this.hideImagesInitially();
		this.initializeSwipe();

		resolve();
	},
	sync: function sync() {
		this.initializeMfpLinks();
		this.initLightbox();

		// Please note: the lazysizes lazybeforeunveil event does not seem to get fired in
		// a reliable way in IE 11, that's why we do the polyfill a first time here and also add a 3s timeout to do it again
		this.objectFitIEPolyfill();
		setTimeout(this.objectFitIEPolyfill.bind(this), 3000);
	},
	initializeMfpLinks: function initializeMfpLinks() {
		var _this = this;

		// we use the terrific module instance id to namespace multiple instances of galleries on one page
		var galleryId = this.$ctx.data('t-id');

		$.each(this.$images, function (index, image) {
			var $image = $(image);
			var imageIndex = $image.data('image-index');
			var $imageMfp = $image.siblings(_this._selectors.imageMfp);

			var imageMfpLink = '#gallery-' + galleryId + '-image-' + imageIndex;
			var imageMfpTarget = 'gallery-' + galleryId + '-image-' + imageIndex;

			$image.attr('data-mfp-src', imageMfpLink);
			$imageMfp.attr('id', imageMfpTarget);
		});
	},
	initializeSwipe: function initializeSwipe() {
		var $leftArrow = $(this._selectors.galleryLeftArrow);
		var $rightArrow = $(this._selectors.galleryRightArrow);

		$('body').swipe({
			swipeRight: function swipeRight() {
				return $leftArrow.magnificPopup('prev');
			},
			swipeLeft: function swipeLeft() {
				return $rightArrow.magnificPopup('next');
			},
			threshold: 50
		});

		// Initially disable
		$('body').swipe('disable');
	},
	hideImagesInitially: function hideImagesInitially() {
		// Call twice because two rows are shown initially
		this.currentlyShownImages = this.getNextRowStart(this.getNextRowStart(0));
		this.$images.slice(this.currentlyShownImages, 99).hide();

		if (this.currentlyShownImages >= this.$images.length) {
			this.$button.hide();
		}
	},


	// Returns the index for the next row depending on whether the layout is (1/2) or (1/3)
	getNextRowStart: function getNextRowStart(imageIndex) {
		if ($(this.$images.get(imageIndex)).hasAttr(this._selectors.wideImage)) {
			return imageIndex + 2;
		}

		return imageIndex + 3;
	},
	$onButtonClick: function $onButtonClick() {
		// Depending on the current row either two 1/2 or three 1/3 previews will be shown
		var nextIndex = this.getNextRowStart(this.currentlyShownImages);

		this.$images.slice(this.currentlyShownImages, nextIndex).show();

		if (nextIndex >= this.$images.length) {
			this.$button.hide();
		}

		this.currentlyShownImages = nextIndex;

		// check for image polyfill again, since it does not seem to be done on hidden images
		this.objectFitIEPolyfill();
	},
	objectFitIEPolyfill: function objectFitIEPolyfill() {
		var _this2 = this;

		var imgTags = this.$images.find(this._selectors.imageImg);

		if (typeof Modernizr !== 'undefined' && !Modernizr.objectfit) {
			imgTags.each(function (index, image) {
				var $image = $(image);
				var $imageComponent = $image.parent().parent().parent();
				var src = $image.prop('currentSrc');

				if (!src) {
					src = $image.prop('src');
				}

				if (src && src !== '') {
					$imageComponent.css('backgroundImage', 'url(' + src + ')');
					$imageComponent.addClass(_this2._stateClasses.objectfitPolyfill);
				}
			});
		}
	},
	initLightbox: function initLightbox() {
		this.$images.magnificPopup({
			type: 'inline',
			midClick: true,
			closeMarkup: "<button title='%title%' type='button' class='mfp-close'><svg class='a-icon a-icon--primary i i-close'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#close'></use></svg></button>",
			gallery: {
				enabled: true,
				arrowMarkup: "<button title='%title%' type='button' class='mfp-arrow mfp-arrow-%dir% mfp-prevent-close'><svg class='a-icon a-icon--primary a-icon--xl i i-slider-left'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#slider-left'></use></svg></button>"
			},
			fixedContentPos: true,
			fixedBgPos: true
		});

		this.$images.on('mfpOpen', this.onOpenPopup.bind(this));
		this.$images.on('mfpClose', this.onClosePopup.bind(this));
	},
	onOpenPopup: function onOpenPopup() {
		$('body').swipe('enable');
	},
	onClosePopup: function onClosePopup() {
		$('body').swipe('disable');
	},


	/**
  * Event when an image has been loaded and is ready to unveil, Please note: this event does not seem to get fired in
  * a reliable way in IE 11, that's why we do the polyfill always for all images and also call it initially
  *
  * @param {Event} ev The event from the lazysizes plugin
  * @returns {void}
  */
	onBeforeUnveilImage: function onBeforeUnveilImage(ev) {
		var $target = $(ev.target);

		// check if the event is actually coming from an image in this gallery instance
		if ($target.closest(this.$ctx).length > 0) {
			this.objectFitIEPolyfill();
		}
	}
});